<div (click)="onCheckBoxClicked()" class="checkbox noselect"
     fxLayoutAlign="start center">
    <ng-container *ngIf="inputModel">
        <ng-content select=".on"></ng-content>
        <img src="./assets/images/icons/icon-switch-on.svg">

    </ng-container>

    <ng-container *ngIf="!inputModel">
        <ng-content select=".off"></ng-content>
        <img src="./assets/images/icons/icon-switch-off.svg">

    </ng-container>


</div>

